import { type ReactNode } from "react";
import { useField } from "formik";

import { RadioGroup } from "@vega-core/components/Form/Controls/Radio/RadioGroupField/RadioGroupField";
import { m } from "@vega-core/paraglide/messages";
import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  isOptional?: boolean;
  label?: string;
  positiveLabel?: string;
  negativeLabel?: string;
  name: string;
  touched?: boolean;
  onChange?: (value?: boolean) => void;
  content?: ReactNode;
  isInlineList?: boolean;
  disabled?: boolean;
};

export function RadioGroupBooleanField({
  content,
  isOptional,
  positiveLabel,
  negativeLabel,
  onChange,
  label,
  name,
  touched,
  isInlineList = true,
  disabled = false,
}: Props) {
  const [field, meta, helpers] = useField<boolean | undefined>(name);

  const yesNoOptions = [
    {
      title: positiveLabel ?? m.btn_yes(),
      value: "true",
      content,
    },
    {
      title: negativeLabel ?? m.btn_no(),
      value: "false",
      content,
    },
  ];

  const getTouchedProperty = () => {
    if (touched !== undefined) {
      return touched;
    }

    return meta.touched;
  };

  return (
    <RadioGroup
      disabled={disabled}
      error={
        getTouchedProperty() && isTruthy(meta.error) ? meta.error : undefined
      }
      isInlineList={isInlineList}
      items={yesNoOptions}
      name={name}
      onBlur={field.onBlur}
      setChange={(value, checked) => {
        const res = checked && isOptional ? undefined : value === "true";
        helpers.setValue(res);

        onChange && onChange(res);
      }}
      title={label}
      value={
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        field.value !== undefined && field.value !== null
          ? field.value.toString()
          : undefined
      }
    />
  );
}
